
/**
 * replace: { 'min': '10', 'max': '20' }
 * will replace all occurrences of '{min}' with '10' and '{max}' with '20'
 */
function translateDict(dict, lang, key, alt, replace = {}, checkMissing = false) {
  const entry = dict?.[key];
  if (!entry) {
    if (checkMissing) return {
      missing: true,
      result: alt ?? key
    };
    return alt ?? key;
  }
  let result = entry[lang] ?? entry['en'] ?? alt ?? key;

  // Simple replacement logic
  Object.entries(replace).forEach(([k, v]) => {
    const pattern = new RegExp(`\\{${k}\\}`, 'g');
    result = result.replace(pattern, v);
  });
  return result;
}

export function translateWithLang(translations, lang, key, alt = null, replace = {}) {
  // auto-detect namespace based on key prefix
  if (key?.startsWith('tooltips.')) {
    return translateDict(translations.tooltips, lang, key, alt, replace);
  }
  if (key?.startsWith('dropdowns.')) {
    return translateDict(translations.dropdowns, lang, key, alt, replace);
  }
  return translateDict(translations.global, lang, key, alt, replace);
}

export function makeTranslator(translations, lang) {
  const translate = (key, alt = null, replace = {}, checkMissing = false) => {

    if (key?.startsWith('tooltips.')) {
      return translateTooltip(key, alt, replace, checkMissing);
    }

    if (key?.startsWith('dropdowns.')) {
      return translateDropdown(key, alt, replace, checkMissing);
    }

    return translateDict(translations.global, lang, key, alt, replace, checkMissing);
  };

  const translateTooltip = (key, alt = null, replace = {}, checkMissing = false) =>
    translateDict(translations.tooltips, lang, key, alt, replace, checkMissing);

  const translateDropdown = (key, alt = null, replace = {}, checkMissing = false) =>
    translateDict(translations.dropdowns, lang, key, alt, replace, checkMissing);

  const translateNamespace = (ns, key, alt = null, replace = {}, checkMissing = false) => {
    if (ns === 'tooltips') return translateTooltip(key, alt, replace, checkMissing);
    if (ns === 'dropdowns') return translateDropdown(key, alt, replace, checkMissing);
    return translate(key, alt, replace, checkMissing);
  };

  // Expose translateWithLang but pre-bound with translations
  const translateExplicit = (customLang, key, alt = null, replace = {}) =>
    translateWithLang(translations, customLang, key, alt, replace);

  return {
    translate,
    translateTooltip,
    translateDropdown,
    translateNamespace,
    translateWithLang: translateExplicit,
    lang
  };
}
